import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowRight } = FiIcons;

function Hero({ onRead }) {
  return (
    <section className="hero" id="home">
      <img
        src="https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=1800&q=90"
        alt="Parisian rooftops and the Eiffel Tower at sunset"
      />
      <div className="hero-shade" />
      <motion.div
        className="hero-content"
        initial={{ opacity: 0, y: 28 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9 }}
      >
        <span className="eyebrow light">The Reinvention Issue · No. 09</span>
        <h1>There is an art<br />to beginning again.</h1>
        <p className="script-line">And perhaps you already know how.</p>
        <button className="text-link light-link" onClick={onRead}>
          Read the cover story
          <SafeIcon icon={FiArrowRight} />
        </button>
      </motion.div>
      <div className="hero-caption">Photographed in Paris · Autumn 2025</div>
    </section>
  );
}

export default Hero;